/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IGmpTransferAdapter,
  IGmpTransferAdapterInterface,
} from "../IGmpTransferAdapter";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "address",
        name: "recipientAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "XERC20Address",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "gmpAdapter",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "address",
        name: "XERC20Address",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "executeProposal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IGmpTransferAdapter__factory {
  static readonly abi = _abi;
  static createInterface(): IGmpTransferAdapterInterface {
    return new utils.Interface(_abi) as IGmpTransferAdapterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IGmpTransferAdapter {
    return new Contract(address, _abi, signerOrProvider) as IGmpTransferAdapter;
  }
}
